import FooterSection from "assets/Footer";
import "flowbite";
import useFlashSaleData from "hook/useFlashSaleData";
import { useEffect, useRef, useState } from "react";
import { TbPackageOff } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Navbar from "../assets/Navbar";
import useAllFlashProducts from "hook/useAllFlashProducts";
import useAllFreeDeliveryProducts from "hook/useAllFreeDeliveryProducts";
import RevealOnScroll from "components/RevealOnScroll";
import ScrollToTopButton from "components/ScrollToTopButton";
import ShimmerFreeDelivery from "components/shimmer/ShimmerFreeDelivery";
import CardDesign from "components/cardDesign";

const HotOffer = () => {
  const { flashSaleData, loading } = useFlashSaleData();
  const { allFreeDeliveryProducts, loading1, error } =
    useAllFreeDeliveryProducts();
  const [timeLeft, setTimeLeft] = useState(0);
  // const { allProducts, loading1, error } = useAllFlashProducts();
  const [visibleCount, setVisibleCount] = useState(12);
  const loadMoreRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const flashOfferProducts = allFreeDeliveryProducts.filter(
    (item) => item.flashOffer === 0,
  );
  const productsToShow = flashOfferProducts.slice(0, visibleCount);
  const hasMore = visibleCount < flashOfferProducts.length;
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleCount((prev) =>
            Math.min(prev + 12, flashOfferProducts.length),
          );
        }
      },
      {
        rootMargin: "100px",
      },
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [hasMore, flashOfferProducts.length]);

  useEffect(() => {
    if (flashSaleData) {
      if (flashSaleData.available === false) {
        setIsVisible(false);
        return;
      }
      setIsVisible(true);
      setTimeLeft(Math.floor(flashSaleData.remaining_seconds));
    }
  }, [flashSaleData]);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsVisible(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (totalSeconds) => {
    totalSeconds = Math.max(0, Math.floor(totalSeconds));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
  };

  const { days, hours, minutes, seconds } = formatTime(timeLeft || 0);
  if (loading1 || loading) return <ShimmerFreeDelivery />;

  // if (!isVisible) return null;
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="mx-auto w-full mb-4">
        <RevealOnScroll>
          <section className="bg-gradient-to-r from-rose-600 via-orange-500 to-amber-500 p-4 sm:px-10 text-white shadow-lg">
            <div className="mb-3 flex items-center justify-between gap-3">
              <div>
                <h1 className="text-2xl font-extrabold sm:text-3xl">
                  Hot Offers
                </h1>
                <p className="text-sm text-rose-100 sm:text-base">
                  Exclusive discounted products for a limited time.
                </p>
              </div>
              <span className="rounded-full bg-white/20 px-3 py-1 text-xs font-semibold sm:text-sm">
                {productsToShow.length > 0 ? "Offer Active" : "No Active Offer"}
              </span>
            </div>

            <div className="grid grid-cols-4 gap-2 sm:max-w-md">
              {[
                { label: "Days", value: days },
                { label: "Hours", value: hours },
                { label: "Minutes", value: minutes },
                { label: "Seconds", value: seconds },
              ].map((item) => (
                <div
                  key={item.label}
                  className="rounded-lg bg-black/20 px-2 py-2 text-center backdrop-blur"
                >
                  <p className="text-lg font-extrabold sm:text-xl">
                    {String(item.value).padStart(2, "0")}
                  </p>
                  <p className="text-[11px] uppercase tracking-wide text-rose-100 sm:text-xs">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </section>
        </RevealOnScroll>
      </main>
      <div className="container mx-auto relative mt-4 sm:mt-10">
        {/* <div className="mx-auto"> */}
        {productsToShow.length === 0 ? (
          <div className="text-center text-backgroundColor py-10 my-5 ">
            <TbPackageOff className="mx-auto w-40 h-40 mb-5 text-backgroundColor animate-pulse" />
            <h3 className="text-lg font-semibold mb-2 mt-5">
              শীঘ্রই নতুন পণ্যে অফার দেওয়া হবে
            </h3>
          </div>
        ) : (
          <CardDesign likeData={productsToShow} />
        )}
      </div>
      {/* </div> */}

      <FooterSection />
      {showScrollTop && <ScrollToTopButton />}
    </div>
  );
};

export default HotOffer;
